/**
 * Created by jonas on 2021-02-02.
 */
import {GameModel} from "@nolimitcity/slot-game/bin/model/GameModel";
import {BenjiKIVData, BenjiKIVGameData, BenjiKIVInitData, BetWayWins} from "./server/BenjiKIVData";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {BenjiKIV} from "./BenjiKIV";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {BenjiKIVGameMode} from "./server/BenjiKIVGameMode";
import {
    FeatureBuyTimesBetValue
} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {BenjiKIVXBetView} from "./view/general/BenjiKIVXBetView";

export class BenjiKIVModel extends GameModel<BenjiKIVInitData, BenjiKIVGameData> {
    private static RANDOM_REELSET:string[] = ["L1", "L2", "L3", "L4", "L5"];
    private static STACKED_SYMBOL_SYNTAX:string[] = ["_BOT", "_MID", "_TOP"];
    private static SCATTER_POSITIONS:number[][] = [
        [0, 1, 2],
        [3, 4, 5],
        [6, 7, 8],
        [9, 10, 11],
        [12, 13, 14]
    ]

    public isRestore:boolean = false;

    private _freespinsLeft:number;
    private _reels:string[][];
    private _winRatio:number;
    private _accumulatedRoundWin:number = 0;
    private _featureBuyTimesBetValue:FeatureBuyTimesBetValue[];
    private _brokeBank:boolean;
    private _buyFeatureName:string = "";
    private _totalSpinWinnings:number;
    private _wildNudgeReels:number[];
    private _wildLandedFullStackedReels:boolean[];
    private _wildLandedOnReels:boolean[];
    private _mNudgeReels:number[];
    private _evaluatedArea:string[][];
    private _allWinSymPositions:boolean[][];
    private _playedBetValue:number;
    private _enhancerReel:number[];
    private _multiplierScatters:number[];
    private _overlayScatter:number[];
    private _parsedTargetScatterPositions:PIXI.Point[];
    private _sfsIsMoreScatter:boolean;
    private _enhancedBet:number;
    private _nextPlayerInteraction:any;
    private _wasFeatureBuy:boolean;
    private _scattersLanded:number[];
    private _allScattersLanded:number;
    private _midsLandedFull:boolean[];
    private _midSymbolsLandedFull:string[];
    private _playNoWin:boolean;
    private _playNoWinCounter:number = 0;
    private _deadPresidentAnticipationReels:boolean[];
    private _diceAnticipationReels:boolean[];
    private _showTotalWin:boolean;
    private _initDeadPresidents:boolean[];
    private _reelsStackedStatus:boolean[] = [];
    private _totalWaysWon:number;
    private _isWildNudge:boolean;
    private _showRingGirlOnReel:boolean[];
    private _upToMaxWinAmount:number;
    private _isLuckyDrawBet:boolean;
    private _deadPresidentsCounter:number;
    private _deadPresidentReels:boolean[];
    private _badOutcomeReels:boolean[];
    private _goodOutcomeReels:boolean[];
    private _isXBetRedSpecialMode:boolean;
    private _betWayWins:BetWayWins[] = [];

    constructor(api:ApiPlugin, triggerEvents:boolean = true) {
        super(api, triggerEvents);

        api.events.once("featureName", (data:string) => this.onFeatureName(data));
        api.events.on(APIEvent.BET, (betData:APIFeatureBetEventData) => this.onBet(betData));
        api.events.on(APIEvent.ACTION_SPINS_BET, (betData:APIFeatureBetEventData) => this.onBet(betData));

    }

    private onFeatureName(name:string):void {
        BenjiKIV.buyFeatureName = name;
    }

    private onBet(betData:APIFeatureBetEventData):void {
        this._isLuckyDrawBet = false;
        //Reset feature buy name when it's done
        /**
         * All this could probably be simplified to:
         * if(BenjiKIV.buyFeatureName.length > 0 && betData.type == "normalBet") {
         *      BenjiKIV.buyFeatureName = "";
         * }
         */
        if(BenjiKIV.buyFeatureName.length > 0) {
            if((BenjiKIV.model.data.mode == BenjiKIVGameMode.FREESPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.NORMAL)
                || (BenjiKIV.model.data.mode == BenjiKIVGameMode.SUPER_FREESPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.NORMAL)
                || (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.NORMAL)) {
                BenjiKIV.buyFeatureName = "";
            }
            if(betData.type == "normalBet") {
                if(BenjiKIV.buyFeatureName == BenjiKIVXBetView.BOOST_BET_1 || BenjiKIV.buyFeatureName == BenjiKIVXBetView.BOOST_BET_2) {
                    BenjiKIV.buyFeatureName = "";
                }
            }
        }

        if(betData.featureName == "LUCKY_DRAW") {
            this._isLuckyDrawBet = true;
        }
        for(let index:number = 0; index < BenjiKIV.model.featureBuyTimesBetValue.length; index++) {
            if(BenjiKIV.model.featureBuyTimesBetValue[index].name == betData.featureName) {
                BenjiKIV.buyFeatureName = betData.featureName;
                break;
            }
        }
    }

    protected onInit(data:BenjiKIVInitData):void {
        //console.log(data);
        this._evaluatedArea = data.evaluatedArea;
        this._reels = this.addRandomSymbolsToReelset(data.reels, data.isRestoreState);
        this.parseStackedSymbols(this._reels);
        data.reels = this._reels;
        super.onInit(data);
        if(data.multiplierScatters) {
            this._multiplierScatters = data.multiplierScatters;
        }
        if(data.multiplierScatters) {
            this._overlayScatter = data.overlayScatter;
        }
        if(this._overlayScatter) {
            this.parseScatterPositions();
        }
        this._enhancedBet = data.enhancedBet;
        this._enhancerReel = data.enhancerReel;
        this.isRestore = data.isRestoreState;
        this._freespinsLeft = data.freespinsLeft;
        this._featureBuyTimesBetValue = data.featureBuyTimesBetValue;
        this._brokeBank = data.brokeTheBank;
        this._nextPlayerInteraction = data.nextPlayerInteraction;
        this._accumulatedRoundWin = data.accumulatedRoundWin;
        this._initDeadPresidents = this.parseInitDeadPresidents(data);
        this._scattersLanded = this.parseScatterLanded(data);
        this._allScattersLanded = this.parseAllScattersLanded();
        this._showTotalWin = this.parseShowTotalWin();
    }

    public onGame(data:BenjiKIVGameData):void {
        //console.log(data);
        this._wasFeatureBuy = data.wasFeatureBuy;
        this._evaluatedArea = data.evaluatedArea;
        this._reels = this.addRandomSymbolsToReelset(data.reels);
        this.parseStackedSymbols(this._reels);
        data.reels = this._reels;
        this._brokeBank = data.brokeTheBank;
        this._playedBetValue = data.playedBetValue;
        this._enhancedBet = data.enhancedBet;
        if(this._brokeBank == true) {
            this.parseWinOnMaxWin(data);
        }
        this._accumulatedRoundWin = data.accumulatedRoundWin;
        this._totalSpinWinnings = data.totalSpinWinnings;

        data.betWayWins = this.updateBetWayWins(data.betWayWins);
        this._betWayWins = data.betWayWins;
        super.onGame(data);
        this._scattersLanded = this.parseScatterLanded(data);
        this._allScattersLanded = this.parseAllScattersLanded();
        this._sfsIsMoreScatter = this.parseIsSFSMoreScatter(data);
        this._multiplierScatters = data.multiplierScatters;
        this._overlayScatter = data.overlayScatter;
        this.parseScatterPositions();
        this._enhancerReel = data.enhancerReel;
        this.parseWildNudgeOnReels(data.reels);
        this.parseMNudgeOnReels(data.reels, data.evaluatedArea);
        this.isRestore = false;
        this._freespinsLeft = data.freespinsLeft;
        this._diceAnticipationReels = this.parseDiceAnticipationReels();
        this.parseAllDeadPresidents();
        this._deadPresidentAnticipationReels = this.parseDeadPAnticipationReels();
        this._showTotalWin = this.parseShowTotalWin();
        this._reelsStackedStatus = this.parseReelsStackedStatus();
        this._isWildNudge = this.parseIsWildNudge();
        this._showRingGirlOnReel = this.parseShowRingGirlOnReel();
        this._playNoWin = this.parsePlayNoWin(data);
        this.parseBadOutcomeReels(data);
        this.parseGoodOutcomeReels(data);
        this._isXBetRedSpecialMode = this.parseXBetRedSpecialMode();
    }

    private parseXBetRedSpecialMode():boolean {
        if(BenjiKIV.model.isRestore == false) {
            return (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL
                    && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.FREESPIN)
                || (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN
                    && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.FREESPIN)
                || (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN)
                || (BenjiKIV.model.data.mode == BenjiKIVGameMode.FREESPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN)
                || (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN)
                || BenjiKIV.model.sfsIsMoreScatter;
        }
        return false;
    }

    private parseGoodOutcomeReels(data:BenjiKIVGameData):void {
        this._goodOutcomeReels = [false, false, false, false, false];
        //In Bonus modes
        if(BenjiKIV.model.data.mode == BenjiKIVGameMode.FREESPIN
            || BenjiKIV.model.data.mode == BenjiKIVGameMode.SUPER_FREESPIN
            || BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN) {
            //If we have a win on 3 connecting reels extend 4th reel stop with 300 ms.
            if(this._allWinSymPositions[0].includes(true)
                && this._allWinSymPositions[1].includes(true)
                && this._allWinSymPositions[2].includes(true)
            ) {
                this._goodOutcomeReels[3] = true;
            }
            //If we have a dead president extend 4th reel stop with 300 ms.
            if(this._deadPresidentReels[0] == true
                || this._deadPresidentReels[1] == true
                || this._deadPresidentReels[2] == true
            ) {
                this._goodOutcomeReels[3] = true;
            }
            //If we have a win connecting 4 reels extend 5th reel stop with 300 ms.
            if(this._allWinSymPositions[0].includes(true)
                && this._allWinSymPositions[1].includes(true)
                && this._allWinSymPositions[2].includes(true)
                && this._allWinSymPositions[3].includes(true)
            ) {
                this._goodOutcomeReels[4] = true;
            }
            //If we have 2 dead presidents of same symbol after 4th reel extend 5th reel stop with 300 ms.
            const deadP:string[] = [];
            for(let i:number = 0; i < 4; i++) {
                if(this._deadPresidentReels[i] == true) {
                    if(deadP.includes(data.reels[i][4])) {
                        this._goodOutcomeReels[4] = true;
                        break;
                    }
                    deadP.push(data.reels[i][4]);
                }
            }
        }
    }

    private parseBadOutcomeReels(data:BenjiKIVGameData):void {
        this._badOutcomeReels = [false, false, false, false, false];
        //If no win and no dead president and no dice on first 3 reels, quick stop reel 4 and 5 in sequence.
        if(data.betWayWins.length == 0 && this._deadPresidentsCounter == 0
            && this._scattersLanded[0] == -1 && this._scattersLanded[1] == -1
            && this._scattersLanded[2] == -1) {
            this._badOutcomeReels[3] = true;
            this._badOutcomeReels[4] = true;
        }
        //If one dead president on first 3 reels but not on 4 and no dice on first 4 reels quick stop reel 5.
        if(this._deadPresidentReels[3] == false && (this._deadPresidentReels[0] == true
            || this._deadPresidentReels[1] == true
            || this._deadPresidentReels[2] == true)) {
            if(this._scattersLanded[0] == -1
                && this._scattersLanded[1] == -1
                && this._scattersLanded[2] == -1
                && this._scattersLanded[3] == -1) {
                this._badOutcomeReels[4] = true;
            }
        }
        //If 2 dead presidents active but no matching 2 dead presidents and respin not triggered after reel 4, quick stop reel 5.
        //Jerker : No win, no respin and dead presidents on reel 0-3?
    }

    //If max win, the win amount should only be what's left to reach max win amount
    private parseWinOnMaxWin(data:BenjiKIVGameData):void {
        const maxWinAmount:number = data.playedBetValue * 10000;
        this._upToMaxWinAmount = -1;
        if((this._accumulatedRoundWin + data.accumulatedRoundWin) > maxWinAmount) {
            this._upToMaxWinAmount = (maxWinAmount - this._accumulatedRoundWin);
        }
        //If two max wins back to back with Red X-bet
        //If max win on red x-bet, we should not do calculations with previous win
        if(this._enhancedBet && this._enhancedBet == 2) {
            this._upToMaxWinAmount = -1
        }
    }

    private parseShowRingGirlOnReel():boolean[] {
        const showRingGirl:boolean[] = [false, false, false, false, false];
        if(this._enhancerReel) {
            //If xSplit on reel 0-2, show ring girl
            for(let i:number = 0; i < 3; i++) {
                if(this._enhancerReel[i] == 1) {
                    showRingGirl[i] = true;
                }
            }
            //If XSplit on reel 3-4
            if(this._enhancerReel[3] == 1 || this._enhancerReel[4] == 1) {
                //Show ring girl on reel 3 if reel 0-2 has one or more win sym on each reel
                if(this._allWinSymPositions[0].includes(true) && this._allWinSymPositions[1].includes(true) && this._allWinSymPositions[2].includes(true)) {
                    showRingGirl[3] = true;
                } else {
                    //Show ring girl on reel 3 if reel 0-2 has one or more fullstacked landed dead president
                    if(this._midsLandedFull[0] == true || this._midsLandedFull[1] == true || this._midsLandedFull[2] == true) {
                        showRingGirl[3] = true;
                    }
                }
                //Show ring girl on reel 4 if reel 0-3 has one or more win sym son each reel
                if(this._allWinSymPositions[0].includes(true) && this._allWinSymPositions[1].includes(true) && this._allWinSymPositions[2].includes(true) && this._allWinSymPositions[3].includes(true)) {
                    showRingGirl[4] = true;
                } else {
                    //Show ring girl on reel 4 if reel 0-3 has a landed fullstacked dead president AND one or more of the same symbol landed (nudge and/or fullstacked)
                    let midSymsFound:string[] = [];
                    for(let i:number = 0; i < this._midSymbolsLandedFull.length - 1; i++) {
                        if(this._midSymbolsLandedFull[i].length > 0) {
                            if(midSymsFound.includes(this._midSymbolsLandedFull[i]) == true) {
                                //Two of the same symbol landed full on reel 0-3
                                showRingGirl[4] = true;
                                break;
                            } else {
                                midSymsFound.push(this._midSymbolsLandedFull[i]);
                            }
                        }
                    }
                    for(let i:number = 0; i < this._mNudgeReels.length - 1; i++) {
                        if(this._mNudgeReels[i] !== 0) {
                            //There is a mid sym that should nudge. (Which means that the same symbol already landed fullstacked)
                            showRingGirl[4] = true;
                            break;
                        }
                    }
                }
            }
        }
        return showRingGirl;
    }

    private parseIsWildNudge():boolean {
        for(let i:number = 0; i < BenjiKIV.model.wildNudgeReels.length; i++) {
            if(BenjiKIV.model.wildNudgeReels[i] !== 0) {
                return true;
            }
        }
        return false;
    }

    private updateBetWayWins(betWayWins:BetWayWins[]):BetWayWins[] {
        betWayWins.sort((a:BetWayWins, b:BetWayWins) => {
            return (a.multiplier - b.multiplier);
        });

        this.parseAllWinSymbolPositions(betWayWins);
        this.parseTotalWaysWon(betWayWins);

        if(this._brokeBank) {
            const maxAmount:number = (this._upToMaxWinAmount > -1 ? this._upToMaxWinAmount : this._accumulatedRoundWin);
            let amount:number = 0,
                i:number = 0;

            for(i; i < betWayWins.length; i++) {
                const betWayWin:BetWayWins = betWayWins[i];
                if((maxAmount - amount) <= betWayWin.multipliedAmount) {
                    betWayWin.multipliedAmount = (maxAmount - amount);
                    betWayWin.multiplier = betWayWin.multiplier > 1 ? Math.ceil((betWayWin.multipliedAmount / betWayWin.amount)) : 1;

                    break;
                }

                amount += betWayWin.multipliedAmount;
            }
            for(let j:number = (i + 1); j < betWayWins.length; j++) {
                betWayWins[j].multiplier = 1;
                betWayWins[j].multipliedAmount = betWayWins[j].amount;
            }
        }

        this.modifyBetWayWinsForMultipliers(betWayWins);

        return betWayWins;
    }

    private modifyBetWayWinsForMultipliers(betWayWins:BetWayWins[]):void {
        let amount:number = 0;
        betWayWins.forEach((betWayWin:BetWayWins, index:number) => {
            BenjiKIV.multiplierCountUp.multipliers[index].data = betWayWin;
            BenjiKIV.multiplierCountUp.multipliers[index].startPoint = amount;
            amount += betWayWin.multipliedAmount;
        });
    }

    private parseInitDeadPresidents(data:BenjiKIVInitData):boolean[] {
        const reels:boolean[] = [false, false, false, false, false];
        const activeDead:string[] = [];
        for(let i:number = 0; i < data.reels.length; i++) {
            for(let j:number = 0; j < data.reels[i].length; j++) {
                if(data.reels[i][j].indexOf("W") == -1 && data.reels[i][j].indexOf("_MID") > -1 && j == 4) {
                    if(i < 3) {
                        //Always dead on first 3 reels
                        reels[i] = true;
                        activeDead.push(data.reels[i][j]);
                    } else {
                        if(activeDead.includes(data.reels[i][j])) {
                            reels[i] = true;
                        }
                    }
                }
            }
        }
        return reels;
    }

    private parseDiceAnticipationReels():boolean[] {
        const reels:boolean[] = [false, false, false, false, false];
        let counter:number = 0;
        if(this._wasFeatureBuy == false) {
            if(this._allScattersLanded > 1) {
                //Turn on anticipation on all reels after dice 2 (unless dice 2 is on last reel)
                for(let i:number = 0; i < this._scattersLanded.length; i++) {
                    if(this._scattersLanded[i] > -1) {
                        if(i < 4) {
                            counter++;
                        }
                        if(counter > 1) {
                            for(let j:number = (i + 1); j < 5; j++) {
                                reels[j] = true;
                            }
                        }
                    }
                }
            }
        } else {
            if(this._isLuckyDrawBet == true) {
                //Turn on anticipation on all reels after dice 3 (unless dice 3 is on last reel)
                for(let i:number = 0; i < this._scattersLanded.length; i++) {
                    if(this._scattersLanded[i] > -1) {
                        if(i < 4) {
                            counter++;
                        }
                        if(counter > 2) {
                            for(let j:number = (i + 1); j < 5; j++) {
                                reels[j] = true;
                            }
                        }
                    }
                }
            }
        }

        return reels;
    }

    private parseDeadPAnticipationReels():boolean[] {
        let reels:boolean[] = [false, false, false, false, false];
        if(this._deadPresidentsCounter > 0) {
            reels = [true, true, true, true, true];
            for(let i:number = 0; i < 3; i++) {
                if(this._midsLandedFull[i] == true) {
                    //No anticipation on first reel with dead
                    reels[i] = false;
                    break;
                } else {
                    reels[i] = false;
                }
            }
        }
        //No anticipation on last reel if reel 0-3 together only have one dead P
        let counter:number = 0;
        for(let i:number = 0; i < 4; i++) {
            if(this._deadPresidentReels[i] == true) {
                counter++;
            }
        }
        if(counter == 1) {
            reels[4] = false;
        }

        return reels;


    }

    //Returns all reels that will have dead presidents on them
    private parseAllDeadPresidents():void {
        //Check full stacked landed on first 3 reels
        this._deadPresidentsCounter = 0;
        this._deadPresidentReels = [false, false, false, false, false];
        for(let i:number = 0; i < 3; i++) {
            if(this._midsLandedFull[i] == true) {
                this._deadPresidentsCounter++
                this._deadPresidentReels[i] = true;
            }
        }
        //Check all mids that will nudge into dead
        for(let i:number = 0; i < this._mNudgeReels.length; i++) {
            if(this._mNudgeReels[i] !== 0) {
                this._deadPresidentsCounter++
                this._deadPresidentReels[i] = true;
            }
        }
        //Check if any mids landed full on last 2 reels and if they are dead
        for(let i:number = 3; i < 5; i++) {
            if(this._midsLandedFull[i] == true) {
                let symName:string = this._reels[i][4];
                for(let j:number = 0; j < 3; j++) {
                    if(this._midsLandedFull[j] == true && this._reels[j][4] == symName) {
                        this._deadPresidentsCounter++
                        this._deadPresidentReels[i] = true;
                        break;
                    }
                }
            }
        }
    }

    private parsePlayNoWin(data:BenjiKIVGameData):boolean {
        //We have a win or are in a game mode that shouldn't trigger no win
        if(data.betWayWins.length > 0
            || data.mode == BenjiKIVGameMode.FREESPIN
            || data.mode == BenjiKIVGameMode.SUPER_FREESPIN
            || data.nextMode == BenjiKIVGameMode.FREESPIN
            || data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN
            || data.nextMode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN
        ) {
            return false;
        } else if(data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN && data.accumulatedRoundWin > 0) {
            //End of main game respin and we have a win
            return false;
        } else {
            //Nudging wild and no win
            for(let i:number = 0; i < this._wildNudgeReels.length; i++) {
                if(this._wildNudgeReels[i] !== 0) {
                    return true;
                }
            }
            //At least 7 of same L sym but no win
            const lowSyms:number[] = [0, 0, 0, 0, 0];
            for(let i:number = 0; i < data.reels.length; i++) {
                for(let j:number = 3; j < data.reels[i].length - 3; j++) {
                    if(data.reels[i][j].indexOf("L") > -1) {
                        let symNumber:number = parseFloat(data.reels[i][j].slice(1, 2));
                        symNumber--;
                        lowSyms[symNumber]++;
                    }
                }
            }
            for(let i:number = 0; i < lowSyms.length; i++) {
                if(lowSyms[i] > 6) {
                    return true;
                }
            }
            /*
            //3 or more dead presidents and no win
            let deadCounter:number = 0;
            for(let i:number = 0; i < 3; i++) {
                if(this._midsLandedFull[i] == true) {
                    deadCounter++
                }
            }
            for(let i:number = 0; i < this._mNudgeReels.length; i++) {
                if(this._mNudgeReels[i] !== 0) {
                    deadCounter++
                }
            }
            //Check if any mids landed full on last 2 reels and if they are dead
            for(let i:number = 3; i < 5; i++) {
                if(this._midsLandedFull[i] == true) {
                    let symName:string = this._reels[i][4];
                    for(let j:number = 0; j < 3; j++) {
                        if(this._midsLandedFull[j] == true && this._reels[j][4] == symName) {
                            deadCounter++
                            break;
                        }
                    }
                }
            }

             */

            if(this._deadPresidentsCounter > 2) {
                return true;
            }
        }

        return false;
    }

    /**
     * Returns -1 for none or the position on the reel
     * @param data
     * @private
     */
    private parseScatterLanded(data:BenjiKIVData):number[] {
        const scattersLanded:number[] = [-1, -1, -1, -1, -1];
        for(let i:number = 0; i < data.reels.length; i++) {
            for(let j:number = 0; j < data.reels[i].length; j++) {
                if(data.reels[i][j] == "S") {
                    scattersLanded[i] = j;
                }
            }
        }
        return scattersLanded;
    }

    private parseAllScattersLanded():number {
        let scattersLanded:number = 0;
        for(let i:number = 0; i < this._scattersLanded.length; i++) {
            if(this._scattersLanded[i] > -1) {
                scattersLanded++;
            }
        }
        return scattersLanded;
    }

    private parseIsSFSMoreScatter(data:BenjiKIVGameData):boolean {
        if(data.mode == BenjiKIVGameMode.SUPER_FREESPIN && (data.freespinsLeft > this._freespinsLeft)) {
            return true;
        }
        return false;
    }

    //If it's restore, this will be the overlays starting positions
    private parseScatterPositions():void {
        this._parsedTargetScatterPositions = [];
        if(this._overlayScatter.length > 0) {
            for(let i:number = 0; i < this._overlayScatter.length; i++) {
                this._parsedTargetScatterPositions.push(this.getScatterReelAndRowPosition(this._overlayScatter[i]));
            }
        }
    }

    public overlayScatterOnReel(reelId:number):boolean {
        for(let i:number = 0; i < this._parsedTargetScatterPositions.length; i++) {
            if(this._parsedTargetScatterPositions[i].x == reelId) {
                return true;
            }
        }
        return false;
    }

    public getScatterReelAndRowPosition(value:number):PIXI.Point {
        let position:PIXI.Point = new PIXI.Point();
        for(let i:number = 0; i < BenjiKIVModel.SCATTER_POSITIONS.length; i++) {
            for(let j:number = 0; j < BenjiKIVModel.SCATTER_POSITIONS[i].length; j++) {
                if(BenjiKIVModel.SCATTER_POSITIONS[i][j] == value) {
                    position.x = i;
                    position.y = value - (i * 3);
                    return position;
                }
            }
        }
        return position;
    }

    public getAllScatterPositions():PIXI.Point[] {
        const scatterPositions:PIXI.Point[] = [];
        for(let i:number = 0; i < BenjiKIV.allReelView.reelModels.length; i++) {
            for(let j:number = 0; j < BenjiKIV.allReelView.reelModels[i].reelView.symbols.length; j++) {
                if(BenjiKIV.allReelView.reelModels[i].reelView.symbols[j].symbolName == "S") {
                    if(j > 2 && j < 6) {
                        scatterPositions.push(new PIXI.Point(i, (j - 3)));
                    }
                }
            }
        }
        return scatterPositions;
    }

    private parseAllWinSymbolPositions(betWayWins:BetWayWins[]):void {
        this._allWinSymPositions = [[false, false, false], [false, false, false], [false, false, false], [false, false, false], [false, false, false]];
        if(betWayWins.length > 0) {
            for(let i:number = 0; i < betWayWins.length; i++) {
                for(let j:number = 0; j < betWayWins[i].winPositions.length; j++) {
                    for(let k:number = 0; k < betWayWins[i].winPositions[j].length; k++) {
                        if(betWayWins[i].winPositions[j][k]) {
                            this._allWinSymPositions[j][k] = true;
                        }
                    }
                }
            }
        }
    }

    private parseWildNudgeOnReels(reels:string[][]):void {
        this._wildNudgeReels = [0, 0, 0, 0, 0];
        this._wildLandedOnReels = [false, false, false, false, false];
        this._wildLandedFullStackedReels = [false, false, false, false, false];
        for(let i:number = 0; i < reels.length; i++) {
            for(let j:number = 0; j < reels[i].length; j++) {
                if(reels[i][j].indexOf("W_MID") > -1) {
                    this._wildLandedOnReels[i] = true;
                    if(j == 4) {
                        this._wildLandedFullStackedReels[i] = true;
                    }
                }
                if(reels[i][j].indexOf("W_MID") > -1 && j !== 4) {
                    this._wildNudgeReels[i] = 4 - j;
                    break;
                }
            }
        }
    }

    private parseMNudgeOnReels(reels:string[][], evaluatedArea:string[][]):void {
        this._mNudgeReels = [0, 0, 0, 0, 0];
        this._midsLandedFull = [false, false, false, false, false];
        this._midSymbolsLandedFull = ["", "", "", "", ""];
        for(let i:number = 0; i < reels.length; i++) {
            for(let j:number = 0; j < reels[i].length; j++) {
                if(reels[i][j].indexOf("_MID") > -1 && reels[i][j].length > 5 && j == 4) {
                    this._midsLandedFull[i] = true;
                    this._midSymbolsLandedFull[i] = reels[i][j].slice(0, 2);
                }
                if(reels[i][j].indexOf("_MID") > -1 && reels[i][j].length > 5 && j !== 4) {
                    let symName:string = reels[i][j].slice(0, 2);
                    if(evaluatedArea[i][0] == symName && evaluatedArea[i][1] == symName && evaluatedArea[i][2] == symName) {
                        this._mNudgeReels[i] = 4 - j;
                        break;
                    }
                }
            }
        }
    }

    //We need an extra row at the top and the bottom because of the stacked symbols
    private addRandomSymbolsToReelset(reels:string[][], isRestore:boolean = false):string[][] {
        for(let i:number = 0; i < reels.length; i++) {
            reels[i].push(this.getRandomSymbolInReelSet());
            reels[i].unshift(this.getRandomSymbolInReelSet());
            reels[i].push(this.getRandomSymbolInReelSet());
            reels[i].unshift(this.getRandomSymbolInReelSet());
            if(reels[i].length == 7) {
                reels[i].push(this.getRandomSymbolInReelSet());
                reels[i].unshift(this.getRandomSymbolInReelSet());
            }
        }
        return reels;
    }

    private parseStackedSymbols(reels:string[][]):string[][] {
        let symbolName01:string = "";
        let symbol01StartIndex:number = 0;
        let symbol01EndIndex:number = 0;
        const parsedReels:string[][] = [];
        for(let i:number = 0; i < reels.length; i++) {
            //Checking all M syms in visible area
            for(let j:number = 3; j < reels[i].length - 3; j++) {
                if((reels[i][j].indexOf("M") > -1 && reels[i][j].length == 2) || (reels[i][j].indexOf("W") > -1 && reels[i][j].length == 1)) {
                    if(symbolName01 == "") {
                        symbolName01 = reels[i][j];
                        symbol01StartIndex = j;
                        symbol01EndIndex = j;
                    } else if(symbolName01 == reels[i][j]) {
                        symbol01EndIndex++;
                    }
                }
            }
            if(symbolName01.length > 0) {
                let bottomIndex:number = symbol01EndIndex;
                bottomIndex = symbol01EndIndex;

                if(symbol01StartIndex > 3) {
                    bottomIndex = symbol01StartIndex + 2;
                }

                for(let k:number = 0; k < 3; k++) {
                    reels[i][bottomIndex - k] = symbolName01 + BenjiKIVModel.STACKED_SYMBOL_SYNTAX[k];
                }
                symbolName01 = "";
            }
        }

        //Checking if top padding or bottom padding sym is stacked M
        for(let i:number = 0; i < reels.length; i++) {
            let symName:string;
            if((reels[i][2].length == 2 && reels[i][2].indexOf("M") > -1) || (reels[i][2].length == 1 && reels[i][2].indexOf("W") > -1)) {
                symName = reels[i][2];
                for(let j:number = 0; j < 3; j++) {
                    reels[i][j] = symName + BenjiKIVModel.STACKED_SYMBOL_SYNTAX[2 - j];
                }
            }
            if((reels[i][6].length == 2 && reels[i][6].indexOf("M") > -1) || (reels[i][6].length == 1 && reels[i][6].indexOf("W") > -1)) {
                symName = reels[i][6];
                for(let j:number = 0; j < 3; j++) {
                    reels[i][6 + j] = symName + BenjiKIVModel.STACKED_SYMBOL_SYNTAX[2 - j];
                }
            }
        }

        return reels;
    }

    private parseShowTotalWin():boolean {
        return (this.isReSpinMode(this.data.mode) || this.isReSpinMode(this.data.nextMode) ||
            this.isFreeSpinMode(this.data.mode) || this.isFreeSpinMode(this.data.nextMode));
    }

    private isReSpinMode(mode:string):boolean {
        //Only show total win if respin NO red xbet
        return (mode === BenjiKIVGameMode.NORMAL_EXTRA_SPIN && BenjiKIV.model.enhancedBet !== 2);
    }

    private isFreeSpinMode(mode:string):boolean {
        return this.data.freespinTriggeredThisSpin || mode === BenjiKIVGameMode.FREESPIN || mode === BenjiKIVGameMode.SUPER_FREESPIN;
    }

    get reelsStackedStatus():boolean[] {
        return this._reelsStackedStatus;
    }

    get freespinsLeft():number {
        return this._freespinsLeft;
    }

    set freespinsLeft(value:number) {
        this._freespinsLeft = value;
    }

    get reels():string[][] {
        return this._reels;
    }

    get winRatio():number {
        if(this._brokeBank == true) {
            if(this._upToMaxWinAmount > -1) {
                this._winRatio = MathHelper.ceilToDecimals((this._upToMaxWinAmount / this._playedBetValue), 2);
            } else {
                this._winRatio = MathHelper.ceilToDecimals((this._accumulatedRoundWin / this._playedBetValue), 2);
            }
        } else if(BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL) {
            this._winRatio = MathHelper.ceilToDecimals((this._accumulatedRoundWin / this._playedBetValue), 2);
        } else {
            this._winRatio = MathHelper.ceilToDecimals((this._totalSpinWinnings / this._playedBetValue), 2);
        }

        return this._winRatio;
    }

    get accumulatedRoundWin():number {
        return this._accumulatedRoundWin;
    }

    get featureBuyTimesBetValue():FeatureBuyTimesBetValue[] {
        return this._featureBuyTimesBetValue;
    }

    get brokeBank():boolean {
        return this._brokeBank;
    }

    get buyFeatureName():string {
        return this._buyFeatureName;
    }

    set buyFeatureName(value:string) {
        this._buyFeatureName = value;
    }

    get totalSpinWinnings():number {
        return this._totalSpinWinnings;
    }

    get wildNudgeReels():number[] {
        return this._wildNudgeReels;
    }

    get wildLandedOnReels():boolean[] {
        return this._wildLandedOnReels;
    }

    get mNudgeReels():number[] {
        return this._mNudgeReels;
    }

    get allWinSymPositions():boolean[][] {
        return this._allWinSymPositions;
    }

    get multiplierScatters():number[] {
        return this._multiplierScatters;
    }

    get parsedTargetScatterPositions():PIXI.Point[] {
        return this._parsedTargetScatterPositions;
    }

    get sfsIsMoreScatter():boolean {
        return this._sfsIsMoreScatter;
    }

    get enhancedBet():number {
        return this._enhancedBet;
    }

    get nextPlayerInteraction():any {
        return this._nextPlayerInteraction;
    }

    get wasFeatureBuy():boolean {
        return this._wasFeatureBuy;
    }

    get scattersLanded():number[] {
        return this._scattersLanded;
    }

    get playNoWin():boolean {
        return this._playNoWin;
    }

    get midsLandedFull():boolean[] {
        return this._midsLandedFull;
    }

    get deadPresidentAnticipationReels():boolean[] {
        return this._deadPresidentAnticipationReels;
    }

    get showTotalWin():boolean {
        return this._showTotalWin;
    }

    get initDeadPresidents():boolean[] {
        return this._initDeadPresidents;
    }

    get wildLandedFullStackedReels():boolean[] {
        return this._wildLandedFullStackedReels;
    }

    get totalWaysWon():number {
        return this._totalWaysWon;
    }

    get allScattersLanded():number {
        return this._allScattersLanded;
    }

    private getRandomSymbolInReelSet():string {
        const randomIndex = Math.floor(Math.random() * BenjiKIVModel.RANDOM_REELSET.length);
        return BenjiKIVModel.RANDOM_REELSET[randomIndex];
    }

    get isWildNudge():boolean {
        return this._isWildNudge;
    }

    get showRingGirlOnReel():boolean[] {
        return this._showRingGirlOnReel;
    }

    get upToMaxWinAmount():number {
        return this._upToMaxWinAmount;
    }

    get diceAnticipationReels():boolean[] {
        return this._diceAnticipationReels;
    }

    get isLuckyDrawBet():boolean {
        return this._isLuckyDrawBet;
    }

    get badOutcomeReels():boolean[] {
        return this._badOutcomeReels;
    }

    get goodOutcomeReels():boolean[] {
        return this._goodOutcomeReels;
    }

    get isXBetRedSpecialMode():boolean {
        return this._isXBetRedSpecialMode;
    }

    get betWayWins():BetWayWins[] {
        return this._betWayWins;
    }

    private parseReelsStackedStatus():boolean[] {
        let retVal:boolean[] = [false, false, false, false, false];

        for(let i:number = 0; i < this._evaluatedArea.length; i++) {
            const firstSymbol:string = this._evaluatedArea[i][0];

            if(firstSymbol.indexOf("M") > -1 || firstSymbol.indexOf("W") > -1) {
                let sameSymbol:boolean = true;

                for(let j:number = 1; j < this._evaluatedArea[i].length; j++) {
                    if(firstSymbol !== this._evaluatedArea[i][j]) {
                        sameSymbol = false;
                    }
                }

                if(sameSymbol) {
                    retVal[i] = true;
                }
            }
        }

        return retVal;
    }

    private parseTotalWaysWon(betWayWins:BetWayWins[]):void {
        this._totalWaysWon = 0;

        for(let i:number = 0; i < betWayWins.length; i++) {
            this._totalWaysWon += betWayWins[i].numberOfCombinations;
        }
    }
}